import React, { FC, useCallback, useMemo } from 'react';
import { Slider } from 'antd';
import styles from './StepRangeSlider.module.less';

export type StepRangeSliderValue = {
  from?: number;
  to?: number;
};

type Props = {
  value?: StepRangeSliderValue;
  onChange?: (value?: StepRangeSliderValue) => void;
  steps: number[];
  prefix?: string;
};

export const StepRangeSlider: FC<Props> = (props) => {
  const { steps, value: propVal, prefix, onChange } = props;
  const tipFormatter = useCallback(
    (value) => {
      return `${prefix ?? ''}${steps[value]?.toLocaleString() ?? ''}`;
    },
    [prefix, steps],
  );
  const value: [number, number] = useMemo(() => {
    const fromIdx = steps.indexOf(propVal?.from ?? steps[0]);
    const toIdx = steps.indexOf(propVal?.to ?? steps[steps.length - 1]);
    return [fromIdx, toIdx];
  }, [propVal?.from, propVal?.to, steps]);

  const handleChange = useCallback(
    (val) => {
      onChange?.({ from: steps[val[0]], to: steps[val[1]] });
    },
    [onChange, steps],
  );
  return (
    <Slider
      className={styles.stepRangeSlider}
      range
      step={1}
      max={steps.length - 1}
      tipFormatter={tipFormatter}
      value={value}
      onChange={handleChange}
    />
  );
};
